//import Vue from 'vue'
import Home from '../pages/Home'
import NotFound from '@/pages/NotFound'
import Promise from 'promise-polyfill'
//第三方组件

//好股
const HaoGuHome = r => require.ensure([], () => r(require('../pages/Haogu/Home')), 'group-haogu')
const JueZhanIndex = r => require.ensure([], () => r(require('../pages/Haogu/Juezhan')), 'group-haogu')
const XingTai = r => require.ensure([], () => r(require('../pages/Haogu/XingTai')), 'group-haogu')
const ZiJing = r => require.ensure([], () => r(require('../pages/Haogu/ZiJing')), 'group-haogu')
const JiMi = r => require.ensure([], () => r(require('../pages/Haogu/Jimiqingbao')), 'group-haogu')
const Note = r => require.ensure([], () => r(require('../pages/Haogu/PolicyNote')), 'group-haogu')
const FinancingDetail = r => require.ensure([], () => r(require('../pages/Financing/Detail')), 'group-haogu')
const FinancingSkill = r => require.ensure([], () => r(require('../pages/Financing/Skill')), 'group-haogu')

//公告
const AnnouncementList = r => require.ensure([], () => r(require('../pages/Announcement/List')), 'Ann-list')
const AnnouncementDetail = r => require.ensure([], () => r(require('../pages/Announcement/Detail')), 'Ann-Detail')
//股票相关
const StockNorm = r => require.ensure([], () => r(require('../pages/Stock/Norm')), 'group-stock-norm')
const JiePan = r => require.ensure([], () => r(require('../pages/Stock/JiePan')), 'group-stock-jiepan')
const LongHu = r => require.ensure([], () => r(require('../pages/Stock/LongHu')), 'group-stock-longhu')
const YingYeTing = r => require.ensure([], () => r(require('../pages/Stock/YingYeTing')), 'group-stock-yingyeting')
const CaiBao = r => require.ensure([], () => r(require('../pages/Stock/CaiBao')), 'group-stock-caibao')
const NewsList = r => require.ensure([], () => r(require('../pages/Stock/NewsList')), 'group-stock-news-list')
//各类文案
const Agreement = r => require.ensure([], () => r(require('../pages/Doc/UserAgreement')), 'group-doc')
const Warning = r => require.ensure([], () => r(require('../pages/Doc/Warning')), 'group-doc')
const IosAppStore = r => require.ensure([], () => r(require('../pages/Doc/IosAppStore')), 'group-doc')

// import Agreement from '../pages/Doc/UserAgreement'
// import Warning from '../pages/Doc/Warning'
//F10数据
const DaoPoTianJi = r => require.ensure([], () => r(require('../pages/F10/DaoPoTianJi')), 'group-f10')
const YanBao = r => require.ensure([], () => r(require('../pages/F10/YanBao')), 'group-f10')
const JiGou = r => require.ensure([], () => r(require('../pages/F10/JiGou')), 'group-f10')

import calendartest from '../pages/lab/CalendarTest.vue'

if (!window.Promise) {
  window.Promise = Promise;
}

//Vue.use(Router);

export default new VueRouter({
  //mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/notfound', component: NotFound },
    { path: '/index.html', component: Home },

    { path: '/haogu', component: HaoGuHome },
    { path: '/haogu/juezhan', component: JueZhanIndex },
    { path: '/haogu/xingtai', component: XingTai },
    { path: '/haogu/zijing', component: ZiJing },
    { path: '/haogu/jimi', component: JiMi },
    { path: '/haogu/note/:id', component: Note },

    { path: '/financing/detail/:id/:type', name: 'Financing-Detail-Type', component: FinancingDetail },
    { path: '/financing/detail/:id', name: 'Financing-Detail', component: FinancingDetail },
    { path: '/financing/skill/:id', name: 'Financing-skill', component: FinancingSkill },

    { path: '/announcement/list', name: 'Announcement-List', component: AnnouncementList },
    { path: '/announcement/list/:id', name: 'Announcement-List-id', component: AnnouncementList },
    { path: '/announcement/detail/:date/:id', name: 'Announcement-Detail', component: AnnouncementDetail },

    { path: '/stock/norm/:id', name: 'Stock-Norm', component: StockNorm },
    { path: '/stock/jiepan/:id', name: 'Stock-JiePan', component: JiePan },
    { path: '/stock/longhu/:id', name: 'Stock-LongHu', component: LongHu },
    { path: '/stock/yingyeting/:id', name: 'Stock-YingYeTing', component: YingYeTing },
    { path: '/stock/CaiBao/:id', name: 'F10-CaiBao', component: CaiBao },//研报主页
    { path: '/stock/NewsList', name: 'F10-NewsList', component: NewsList },

    { path: '/doc/agreement', name: 'doc-user-agreement', component: Agreement },
    { path: '/doc/warning', name: 'doc-warning', component: Warning },
    { path: '/doc/appstore', name: 'doc-appstore', component: IosAppStore },

    { path: '/f10/daopotianji/:id', name: 'F10-DaoPoTianJi', component: DaoPoTianJi },
    { path: '/f10/YanBao/:id', name: 'F10-YanBao', component: YanBao },//研报主页
    { path: '/f10/jigou/:id', name: 'F10-jigou', component: JiGou },//机构观点详细
    // { path: '/lab/slider', name: 'test-slider', component: SliderTest },
    //{ path: '/lab/imgview', name: 'LabImageViewPage', component: ImageViewPage }
    { path: '/lab/test', name: 'test', component: calendartest }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js